import { useEffect, useState } from "react";
import axios from "axios";
import DynamicIcon from "../DynamicIcon";
import AppointmentCard from "../AppointmentCard";
import { getNodeApiUrl } from "../../config/api.config";

export default function AssistanceCard({ assistance, accountId, token, apiBaseUrl }) {
    const [appointments, setAppointments] = useState([]);
    const [appointmentsLoading, setAppointmentsLoading] = useState(false);
    const [appointmentsError, setAppointmentsError] = useState(null);
    const [cloginsDetails, setCloginsDetails] = useState({});

    useEffect(() => {
        const fetchAppointments = async () => {
            setAppointmentsLoading(true);
            setAppointmentsError(null);
            try {
                const res = await axios.get(`${apiBaseUrl}/appointments/byAssistanceRequest`, {
                    headers: { 'auth-token': token },
                    params: {
                        assistanceRequestId: assistance._id,
                        accountId: accountId
                    }
                });
                const apps = res.data.data || [];
                setAppointments(apps);
                // Recupero cloginsDetails di tutti gli utenti coinvolti
                const userIds = Array.from(new Set(apps.flatMap(app => (app.users || []).map(u => u._id))));
                if (userIds.length > 0) {
                    const cloginsRes = await axios.get(`${apiBaseUrl}/users/cloginsDetails`, {
                        headers: { 'auth-token': token },
                        params: { userIds: userIds.join(",") }
                    });
                    // Mappa userId -> cloginsDetails
                    const cloginsMap = {};
                    (cloginsRes.data.data || []).forEach(u => {
                        cloginsMap[u._id] = u.cloginsDetails;
                    });
                    setCloginsDetails(cloginsMap);
                }
            } catch (err) {
                setAppointmentsError("Errore nel recupero appuntamenti o cloginsDetails");
            }
            setAppointmentsLoading(false);
        };
        fetchAppointments();
        // eslint-disable-next-line
    }, [assistance._id, accountId, token, apiBaseUrl]);

    const formatDate = (date) => {
        if (!date) return "-";
        const d = new Date(date);
        return d.toLocaleDateString("it-IT") + ' ' + d.toLocaleTimeString("it-IT", { hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div className="bg-white rounded-lg shadow p-4 flex flex-col gap-2 border border-gray-200">
            <div className="flex flex-col gap-1">
                <div className="font-bold text-lg text-green-900">{assistance.code}</div>
                <div className="text-sm text-green-700 font-semibold">{assistance.statusLabel}</div>
            </div>
            <div className="grid grid-cols-2 gap-1 text-sm">
                <div><strong>Creata:</strong> {formatDate(assistance.creationDate)}</div>
                <div><strong>Scadenza:</strong> {formatDate(assistance.expirationDate)}</div>
                <div><strong>Tipo impianto:</strong> {assistance.systemTypeLabel || '-'}</div>
                <div><strong>Garanzia:</strong> {assistance.systemTypeWarranty || '-'}</div>
                <div><strong>Tipo assistenza:</strong> {assistance.assistanceTypeLabel || '-'}</div>
                <div><strong>Descrizione tipo assistenza:</strong> {assistance.assistanceTypeDescription || '-'}</div>
                <div><strong>Pagamento:</strong> {assistance.paymentTypeLabel || '-'}</div>
                <div><strong>Teleassistenza:</strong> {assistance.teleassistenza ? 'Sì' : 'No'}</div>
            </div>
            <div className="mt-2">
                <div className="font-semibold text-green-800 mb-1 text-base">Appuntamenti collegati</div>
                {appointmentsLoading && <div className="text-sm text-gray-600">Caricamento appuntamenti...</div>}
                {appointmentsError && <div className="text-sm text-red-500">{appointmentsError}</div>}
                {appointments.length === 0 && !appointmentsLoading && (
                    <div className="text-sm text-gray-400">Nessun appuntamento collegato</div>
                )}
                {appointments.length > 0 && (
                    <div className="flex flex-col gap-3">
                        {[...appointments]
                            .sort((a, b) => (a.fromDate || 0) - (b.fromDate || 0))
                            .map(app => (
                                <AppointmentCard 
                                    key={app._id}
                                    appointment={app}
                                    token={token}
                                    apiBaseUrl={apiBaseUrl}
                                />
                            ))}
                    </div>
                )}
            </div>
        </div>
    );
}
